import { FC } from 'react';
import { useFilterAttribute } from '../useFilterAttribute';
import styles from '../FilterDrawer.module.scss';

type FilterAttributePanelProps = {
    attribute: string;
    isActive: boolean;
};

/**
 * Always mounted (one per facet), visibility toggled via `hidden` instead of
 * conditional rendering — so every facet's underlying Algolia widget connects
 * and fetches its values as soon as the drawer mounts, matching desktop's
 * always-mounted dropdowns. Switching facets is then a pure visibility flip
 * with no fetch, instead of a cold mount-and-fetch per tap.
 */
export const FilterAttributePanel: FC<FilterAttributePanelProps> = ({ attribute, isActive }) => {
    const { content } = useFilterAttribute(attribute, isActive);

    return (
        <div hidden={!isActive} className={styles.enterForward}>
            {content}
        </div>
    );
};
